import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import _ from 'lodash';

function Seo({
  description,
  lang,
  meta,
  title,
  image,
  noIndex,
  canonical,
  ogTitle,
  ogDescription,
  ogImage
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
            title
            description
            author
          }
        }
      }
    `
  );

  const metaTitle = title || site.siteMetadata.title;
  const metaDescription = description || site.siteMetadata.description;
  const metaImage = image || `${site.siteMetadata.siteUrl}/favicon.png`;
  const metaOgTitle = ogTitle || metaTitle;
  const metaOgDescription = ogDescription || metaDescription;
  const metaOgImage = ogImage || metaImage;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={_.unescape(metaTitle)}
      meta={[
        {
          name: `title`,
          content: _.unescape(metaTitle),
        },
        {
          name: `description`,
          content: _.unescape(metaDescription),
        },
        {
          property: `og:title`,
          content: _.unescape(metaOgTitle),
        },
        {
          property: `og:description`,
          content: _.unescape(metaOgDescription),
        },
        {
          property: `og:image`,
          content: metaOgImage,
        },
        {
          property: `og:type`,
          content: `website`,
        },
      ].concat(meta)}
    >
      {noIndex && <meta name="robots" content="noindex" />}
      {canonical.length > 0 && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  image: ``,
  noIndex: false,
  canonical: ``,
};

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  image: PropTypes.string,
  noIndex: PropTypes.bool,
  canonical: PropTypes.string,
};

export default Seo;
